<template>
    <div class="row no-gutters">
      <template v-for="(item, index) in items">
        <div class="col item-container" :key="item.id">
          <div class="item w-100">
            <div class="item-img"
              :style="{ backgroundImage: 'url(/img/' + category + '/' + item.id + '.png)' }">
            </div>
            <div class="item-body">
              <span class="align-middle">{{ item.fr | capitalize }}</span>
            </div>
          </div>
        </div>
        <div :key="category + '-m-' + index"
             v-if="(index + 1) % 3 === 0" class="w-100 d-block d-sm-none">
        </div>
        <div :key="category + '-d-' + index"
             v-if="index % 4 === 3" class="w-100 d-none d-sm-block">
        </div>
      </template>
      <div v-if="items.length === 0" class="item">Pas de résultats</div>
    </div>
</template>

<script>
const IMG_PATH = '/img/';

export default {
  props: [
    'category',
    'items'
  ],
  filters: {
    picture: (value, category) => `${IMG_PATH}${category}/${value}.png`
  }
};
</script>

<style scoped lang="scss">
  .item {
    background: rgba(255, 255, 255, 0.90);
    line-height: normal;
    box-shadow: 0 0 2px 0 rgba(0,0,0,0.2);

    height: 100%;
  }

  .item-img {
    height: 58px;
    vertical-align: middle;
    text-align: center;

    background-repeat: no-repeat;
    background-position: center center;
  }

  .item-body {
    padding: 0 5px 13px;
    vertical-align: middle;

    font-size: 0.700rem;
    font-family: 'Roboto', sans-serif;
    text-align: center;
    color: #262626;

    @include media-breakpoint-up(sm) {
      & {
        font-size: 0.813rem;
      }
    }

  }

</style>
